import { Dispatch, SetStateAction, useState } from 'react';

/**
 * Hook allows conditional usage of useState. Applicable when state management can be provided as a prop.
 * @param stateExtrinsic - state management from the props
 * @param initialStateValue - state initial value
 */
export function useStateTransmorphic<T>(
  stateExtrinsic?: [T, Dispatch<SetStateAction<T>>],
  initialStateValue?: T,
) {
  const stateIntrinsic = useState<T>(initialStateValue as T);

  return stateExtrinsic ? stateExtrinsic : stateIntrinsic;
}
